<template>
  <nav class="breadcrumbs grid">
    <div class="wrapper">
      <template v-for="(link, index) in links" :key="link.title">
        <ChevronRightIcon v-if="index > 0" class="grey no-mobile-icon" />
        <NuxtLink
          v-if="link.to"
          :to="localePath(link.to)"
          class="link grey t-p-s-130"
        >
          <BreadcrumbContent :index="index" :title="link.title" />
        </NuxtLink>
        <BreadcrumbContent
          v-else
          custom-class="t-p-s-130"
          :index="index"
          :title="link.title"
        />
      </template>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import ChevronRightIcon from '@/assets/icons/chevron-right.svg?component'
import type { BreadcrumbItem } from '~/types/utils'

defineProps<{
  links: BreadcrumbItem[]
}>()

const localePath = useLocalePath()
</script>

<style lang="scss" scoped>
.breadcrumbs {
  margin: rem(10px) 0 rem(30px);

  .no-mobile-icon {
    display: none;

    @include media-up(md) {
      display: inline-block;
    }
  }
}

.wrapper {
  @include column(xs, 12);
  display: flex;
  gap: rem(8px);

  @include media-up(md) {
    gap: rem(12px);
  }
}

.grey {
  color: $layout-text-03;
}

.link {
  transition: color $transition;

  &:hover {
    color: $layout-text-01;
  }
}
</style>
